// Games data - All 50 games from public/games folder
export const gamesData = [
  {
    "id": "55001",
    "title": "55 Seconds",
    "category": "action",
    "description": "Race against time in this fast-paced 55-second challenge",
    "thumbnail": "/thumbnails/55-seconds.png",
    "htmlFile": "/games/55 Seconds/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 2501
  },
  {
    "id": "55002",
    "title": "Auto Platformer",
    "category": "platform",
    "description": "Navigate automatically through challenging platform levels",
    "thumbnail": "/thumbnails/auto-platformer.png",
    "htmlFile": "/games/Auto Platformer/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 1377
  },
  {
    "id": "55003",
    "title": "Avoider",
    "category": "action",
    "description": "Test your reflexes by avoiding obstacles in this intense game",
    "thumbnail": "/thumbnails/avoider.png",
    "htmlFile": "/games/Avoider/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 1799
  },
  {
    "id": "55004",
    "title": "Babel",
    "category": "puzzle",
    "description": "Build your tower to the sky in this strategic puzzle game",
    "thumbnail": "/thumbnails/babel.png",
    "htmlFile": "/games/Babel/index.html",
    "requiresSubscription": false,
    "rating": "4.2",
    "plays": 3266
  },
  {
    "id": "55005",
    "title": "Bird Copter",
    "category": "action",
    "description": "Control a bird helicopter and navigate through challenging obstacles",
    "thumbnail": "/thumbnails/bird-copter.png",
    "htmlFile": "/games/Bird Copter/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 3217
  },
  {
    "id": "55006",
    "title": "Block Tower",
    "category": "puzzle",
    "description": "Stack blocks perfectly to build the tallest tower",
    "thumbnail": "/thumbnails/block-tower.png",
    "htmlFile": "/games/Block Tower/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 1279
  },
  {
    "id": "55007",
    "title": "Bottle Blast",
    "category": "action",
    "description": "Aim and shoot to blast bottles in this exciting shooter",
    "thumbnail": "/thumbnails/bottle-blast.png",
    "htmlFile": "/games/Bottle Blast/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.3",
    "plays": 2925
  },
  {
    "id": "55008",
    "title": "Bubble Blow",
    "category": "puzzle",
    "description": "Pop colorful bubbles in this relaxing match game",
    "thumbnail": "/thumbnails/bubble-blow.png",
    "htmlFile": "/games/Bubble blow/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 2964
  },
  {
    "id": "55009",
    "title": "Cat Jump",
    "category": "platform",
    "description": "Help the cat jump through platforms and avoid dangerous obstacles",
    "thumbnail": "/thumbnails/cat-jump.png",
    "htmlFile": "/games/Cat Jump/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 2823
  },
  {
    "id": "55010",
    "title": "Cat Reaction",
    "category": "action",
    "description": "Test your reaction speed with this quick cat game",
    "thumbnail": "/thumbnails/cat-reaction.png",
    "htmlFile": "/games/Cat Reaction/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 1772
  },
  {
    "id": "55011",
    "title": "Chop Man",
    "category": "action",
    "description": "Chop your way through obstacles in this fast-paced game",
    "thumbnail": "/thumbnails/chop-man.png",
    "htmlFile": "/games/Chop Man/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 3447
  },
  {
    "id": "55012",
    "title": "Dark Village",
    "category": "adventure",
    "description": "Explore a mysterious dark village full of secrets",
    "thumbnail": "/thumbnails/dark-village.png",
    "htmlFile": "/games/Dark Village/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 1504
  },
  {
    "id": "55013",
    "title": "Dingo The Dragon",
    "category": "adventure",
    "description": "Join Dingo the dragon on an epic adventure through magical lands",
    "thumbnail": "/thumbnails/dingo-the-dragon.png",
    "htmlFile": "/games/Dingo The Dragon/game_file/index.html",
    "requiresSubscription": false,
    "rating": "4.2",
    "plays": 2666
  },
  {
    "id": "55014",
    "title": "Duet",
    "category": "action",
    "description": "Control two dots simultaneously in this challenging rhythm game",
    "thumbnail": "/thumbnails/duet.png",
    "htmlFile": "/games/Duet/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 2113
  },
  {
    "id": "55015",
    "title": "Endless Chimney",
    "category": "platform",
    "description": "Climb the endless chimney and avoid obstacles",
    "thumbnail": "/thumbnails/endless-chimney.png",
    "htmlFile": "/games/Endless Chimney/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 3471
  },
  {
    "id": "55016",
    "title": "Fast",
    "category": "racing",
    "description": "Speed through tracks in this high-velocity racing game",
    "thumbnail": "/thumbnails/fast.png",
    "htmlFile": "/games/Fast/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 1018
  },
  {
    "id": "55017",
    "title": "Fighter Aircraft",
    "category": "action",
    "description": "Pilot a fighter jet and take down enemy aircraft in this thrilling shooter",
    "thumbnail": "/thumbnails/fighter-aircraft.png",
    "htmlFile": "/games/Fighter Aircraft/game_file/index.html",
    "requiresSubscription": false,
    "rating": "4.9",
    "plays": 2280
  },
  {
    "id": "55018",
    "title": "Fire Station",
    "category": "action",
    "description": "Manage emergency responses at the fire station",
    "thumbnail": "/thumbnails/fire-station.png",
    "htmlFile": "/games/Fire Station/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 2037
  },
  {
    "id": "55019",
    "title": "Flap 360",
    "category": "action",
    "description": "Flap around in a 360-degree circular challenge",
    "thumbnail": "/thumbnails/flap-360.png",
    "htmlFile": "/games/Flap 360/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 2569
  },
  {
    "id": "55020",
    "title": "Flap Cat",
    "category": "action",
    "description": "Help the cat flap through obstacles in this addictive game",
    "thumbnail": "/thumbnails/flap-cat.png",
    "htmlFile": "/games/Flap Cat/index.html",
    "requiresSubscription": false,
    "rating": "4.3",
    "plays": 1249
  },
  {
    "id": "55021",
    "title": "Fruit Slicer",
    "category": "action",
    "description": "Slice fruits with precision in this satisfying game",
    "thumbnail": "/thumbnails/fruit-slicer.png",
    "htmlFile": "/games/Fruit Slicer/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 1112
  },
  {
    "id": "55022",
    "title": "Ghost Fall",
    "category": "puzzle",
    "description": "Guide the ghost through falling platforms in this spooky challenge",
    "thumbnail": "/thumbnails/ghost-fall.png",
    "htmlFile": "/games/Ghost Fall/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 2202
  },
  {
    "id": "55023",
    "title": "Hanuman Return",
    "category": "adventure",
    "description": "Join Hanuman on an epic mythological adventure",
    "thumbnail": "/thumbnails/hanuman-return.png",
    "htmlFile": "/games/Hanuman Return/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 3269
  },
  {
    "id": "55024",
    "title": "Jewel Crush",
    "category": "puzzle",
    "description": "Match jewels to create explosive combos",
    "thumbnail": "/thumbnails/jewel-crush.png",
    "htmlFile": "/games/Jewel Crush/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 1196
  },
  {
    "id": "55025",
    "title": "Jewels Match",
    "category": "puzzle",
    "description": "Match three or more jewels in this classic puzzle game",
    "thumbnail": "/thumbnails/jewels-match.png",
    "htmlFile": "/games/Jewels Match/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 3265
  },
  {
    "id": "55026",
    "title": "Jump Guy",
    "category": "platform",
    "description": "Test your reflexes as you jump through challenging obstacles and platforms",
    "thumbnail": "/thumbnails/jump-guy.png",
    "htmlFile": "/games/Jump Guy/index.html",
    "requiresSubscription": false,
    "rating": "4.3",
    "plays": 1748
  },
  {
    "id": "55027",
    "title": "Jumpers",
    "category": "platform",
    "description": "Jump from platform to platform in this endless jumper",
    "thumbnail": "/thumbnails/jumpers.png",
    "htmlFile": "/games/Jumpers/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 1815
  },
  {
    "id": "55028",
    "title": "Let Them Fall",
    "category": "puzzle",
    "description": "Strategic puzzle game where timing is everything",
    "thumbnail": "/thumbnails/let-them-fall.png",
    "htmlFile": "/games/Let Them Fall/index.html",
    "requiresSubscription": false,
    "rating": "4.3",
    "plays": 3212
  },
  {
    "id": "55029",
    "title": "Little Big Runners",
    "category": "platform",
    "description": "Run, jump and dodge in this endless runner adventure",
    "thumbnail": "/thumbnails/little-big-runners.png",
    "htmlFile": "/games/Little Big Runners/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 3234
  },
  {
    "id": "55030",
    "title": "Math Rush",
    "category": "puzzle",
    "description": "Solve math problems quickly in this educational rush game",
    "thumbnail": "/thumbnails/math-rush.png",
    "htmlFile": "/games/Math Rush/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 2491
  },
  {
    "id": "55031",
    "title": "Mission Terror",
    "category": "action",
    "description": "Embark on a dangerous mission to eliminate terrorist threats",
    "thumbnail": "/thumbnails/mission-terror.png",
    "htmlFile": "/games/Mission Terror/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 3202
  },
  {
    "id": "55032",
    "title": "Mole Smash",
    "category": "action",
    "description": "Whack moles as they pop up in this classic arcade game",
    "thumbnail": "/thumbnails/mole-smash.png",
    "htmlFile": "/games/Mole Smash/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 1622
  },
  {
    "id": "55033",
    "title": "Ninja Blocker",
    "category": "action",
    "description": "Block attacks with ninja reflexes in this fast game",
    "thumbnail": "/thumbnails/ninja-blocker.png",
    "htmlFile": "/games/Ninja Blocker/index.html",
    "requiresSubscription": false,
    "rating": "4.2",
    "plays": 1025
  },
  {
    "id": "55034",
    "title": "Paper Plane",
    "category": "action",
    "description": "Fly your paper plane through obstacles and collect stars",
    "thumbnail": "/thumbnails/paper-plane.png",
    "htmlFile": "/games/Paper Plane/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 3315
  },
  {
    "id": "55035",
    "title": "Parking",
    "category": "racing",
    "description": "Master the art of parking in challenging scenarios",
    "thumbnail": "/thumbnails/parking.png",
    "htmlFile": "/games/Parking/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 2772
  },
  {
    "id": "55036",
    "title": "Parking Boom",
    "category": "racing",
    "description": "Park cars perfectly to avoid explosive consequences",
    "thumbnail": "/thumbnails/parking-boom.png",
    "htmlFile": "/games/Parking Boom/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 3243
  },
  {
    "id": "55037",
    "title": "Path",
    "category": "puzzle",
    "description": "Find the right path through increasingly complex mazes",
    "thumbnail": "/thumbnails/path.png",
    "htmlFile": "/games/Path/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 1513
  },
  {
    "id": "55038",
    "title": "Pin Ball Rush",
    "category": "action",
    "description": "Classic pinball action with modern twists",
    "thumbnail": "/thumbnails/pin-ball-rush.png",
    "htmlFile": "/games/Pin Ball Rush/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 1696
  },
  {
    "id": "55039",
    "title": "Rock Paper Scissor",
    "category": "puzzle",
    "description": "Play the classic game with strategic twists",
    "thumbnail": "/thumbnails/rock-paper-scissor.png",
    "htmlFile": "/games/Rock Papper Scissor/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.8",
    "plays": 2130
  },
  {
    "id": "55040",
    "title": "Rose Dash",
    "category": "platform",
    "description": "Dash through beautiful rose gardens in this runner",
    "thumbnail": "/thumbnails/rose-dash.png",
    "htmlFile": "/games/Rose Dash/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 3417
  },
  {
    "id": "55041",
    "title": "Sling Birds",
    "category": "puzzle",
    "description": "Sling birds to knock down structures and defeat enemies",
    "thumbnail": "/thumbnails/sling-birds.png",
    "htmlFile": "/games/Sling Birds/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 2538
  },
  {
    "id": "55042",
    "title": "Star Rocket",
    "category": "action",
    "description": "Pilot your rocket through space and collect stars",
    "thumbnail": "/thumbnails/star-rocket.png",
    "htmlFile": "/games/Star Rocket/index.html",
    "requiresSubscription": false,
    "rating": "4.2",
    "plays": 2219
  },
  {
    "id": "55043",
    "title": "Tap Ball",
    "category": "action",
    "description": "Tap to keep the ball bouncing in this addictive game",
    "thumbnail": "/thumbnails/tap-ball.png",
    "htmlFile": "/games/Tap Ball/index.html",
    "requiresSubscription": false,
    "rating": "4.9",
    "plays": 3206
  },
  {
    "id": "55044",
    "title": "Terror Strike",
    "category": "action",
    "description": "Strike back against terror in this intense action game",
    "thumbnail": "/thumbnails/terror-strike.png",
    "htmlFile": "/games/Terror Strike/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.9",
    "plays": 2612
  },
  {
    "id": "55045",
    "title": "Two Cars",
    "category": "racing",
    "description": "Control two cars simultaneously in this challenging racing game",
    "thumbnail": "/thumbnails/two-cars.png",
    "htmlFile": "/games/Two Cars/index.html",
    "requiresSubscription": false,
    "rating": "4.3",
    "plays": 1941
  },
  {
    "id": "55046",
    "title": "Wood Slide",
    "category": "puzzle",
    "description": "Slide wooden blocks to solve intricate puzzles",
    "thumbnail": "/thumbnails/wood-slide.png",
    "htmlFile": "/games/Wood Slide/index.html",
    "requiresSubscription": false,
    "rating": "4.5",
    "plays": 1377
  },
  {
    "id": "55047",
    "title": "Zombie Smasher",
    "category": "action",
    "description": "Smash zombies before they overrun your defenses",
    "thumbnail": "/thumbnails/zombie-smasher.png",
    "htmlFile": "/games/Zombie Smasher/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 3173
  },
  {
    "id": "55048",
    "title": "Zombie Unleashes",
    "category": "action",
    "description": "Survive waves of unleashed zombies in this survival game",
    "thumbnail": "/thumbnails/zombie-unleashes.png",
    "htmlFile": "/games/Zombie Unleashes/game file/index.html",
    "requiresSubscription": false,
    "rating": "4.4",
    "plays": 2138
  },
  {
    "id": "55049",
    "title": "Zombies Layer Viking",
    "category": "action",
    "description": "Viking warriors battle against zombie hordes",
    "thumbnail": "/thumbnails/zombies-layer-viking.png",
    "htmlFile": "/games/Zombies Layer Viking/index.html",
    "requiresSubscription": false,
    "rating": "4.6",
    "plays": 2892
  },
  {
    "id": "55050",
    "title": "Chain",
    "category": "puzzle",
    "description": "Create chain reactions to solve challenging puzzles",
    "thumbnail": "/thumbnails/chain.png",
    "htmlFile": "/games/chain/index.html",
    "requiresSubscription": false,
    "rating": "4.7",
    "plays": 2309
  }
];

export const categories = [
  { id: 'all', name: 'All Games', icon: '🎮' },
  { id: 'action', name: 'Action', icon: '⚡' },
  { id: 'puzzle', name: 'Puzzle', icon: '🧩' },
  { id: 'platform', name: 'Platform', icon: '🏃' },
  { id: 'racing', name: 'Racing', icon: '🏎️' },
  { id: 'adventure', name: 'Adventure', icon: '🗺️' }
];

export const getAllGames = () => {
  return gamesData;
};

export const getGamesByCategory = (category) => {
  if (category === 'all') {
    return gamesData;
  }
  return gamesData.filter(game => game.category === category);
};

export const getGameById = (gameId) => {
  return gamesData.find(game => game.id === gameId) || null;
};

export const searchGames = (searchTerm) => {
  if (!searchTerm) {
    return gamesData;
  }
  return gamesData.filter(game => 
    game.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    game.description.toLowerCase().includes(searchTerm.toLowerCase())
  );
};
